// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"9a43e061","161":"fad443fb","477":"2260ee67","744":"5b6f9e3e","801":"ded6dae3","980":"28c662eb"}[chunkId] + ".chunk.js";
};